export enum LightshowSegmentTypes {
  Unknown = -1,
  vibrate = 3,
  toggleColors = 5,
  screenStrobe = 6,
  setImageAndBackgroundColor = 31,
  setImage = 16,
  addAudioLayer = 44,
}
